<template>
  <b-modal
    id="news-delete-modal"
    title="Confirm Delete"
    centered>
    <p class="modal-main-message">Are you sure you want delete this item:</p>
    <h3 class="modal-secondary-message">{{ this.newsDetail.name }}</h3>
    <div slot="modal-footer">
      <b-btn
        variant="ghost"
        v-bind:disabled="saving || popupSaving"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'news-delete-modal')">
        Cancel
      </b-btn>
      <b-btn
        variant="primary"
        v-bind:disabled="saving || popupSaving"
        class="ml-1" @click="handleDeleteNews">
        {{ saving || popupSaving ? "Deleting..." : "Yes, Delete" }}
      </b-btn>
      <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "ConfirmDeleteNewsItem",
  props: ["newsDetail"],
  computed: {
  ...mapState("news", [
      "news",
      "newsDetails",
      "nextPage",
      "prevPage",
      "maxPage",
      "currentPage",
      "totalPerPage",
      "searching",
      "categories",
      "loading",
      "editing",
      "currentFirstItem",
      "currentLastItem",
      "customerNames",
      "errors"
    ]),
    ...mapGetters({
      saving: "engagementNews/saving",
      popupErrors: "engagementPopup/errors",
      popupSaving: "engagementPopup/saving"
    })
  },
  methods: {
    ...mapActions({
      deleteNews: "engagementNews/deleteNews",
      deletePopUp: "engagementPopup/deletePopUp"
    }),
    async handleDeleteNews() {
      let _this = this;

      switch (this.newsDetail.type) {
        case "news":
          await this.deleteNews(this.newsDetail.uuid)
            .then(() => {
              _this.$root.$emit("bv::hide::modal", "news-delete-modal");
              if (_this.errors == null) this.$root.$emit("fetch-news-and-popup");
            });
          break;
        case "popup":
          await this.deletePopUp(this.newsDetail.uuid)
            .then(() => {
              _this.$root.$emit("bv::hide::modal", "news-delete-modal");
              if (_this.popupErrors == null) this.$root.$emit("fetch-news-and-popup");
            });
          break;
      }
    }
  }
}
</script>
